import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import React, {memo} from 'react'

import Routes, {getHref} from '../../../../../routes'
import ButtonLink from '../../components/common/ButtonLink/ButtonLink'
import usePermissionCanEditProject from '../../hooks/usePermissionCanEditProject'

import styles from './IndexHeader.css'

function IndexHeader() {
  const canEditProject = usePermissionCanEditProject()

  return (
    <div className={styles.header}>
      <div className={styles.heading}>
        <H1 className={styles.title}>{'All Pipelines'}</H1>
      </div>
      <div className={styles.actions}>
        {canEditProject && (
          <ButtonLink to={getHref(Routes.CREATE_PIPELINE)} primary>
            {'Create new pipeline'}
          </ButtonLink>
        )}
      </div>
    </div>
  )
}

export default memo(IndexHeader)
